const deMessages = {
  /* 01.General */

  "main.name": "Name",
  "main.sentiment": "Stimmung",
  "main.urgency": "Dringlichkeit",
  "main.language": "Sprache",
  "main.agent": "Agent",
  "main.property_name": "Name der Unterkunft",
  "main.booking_number": "Buchungsnummer",
  "main.check_out": "Auschecken",
  "main.check_in": "Einchecken",
  "main.adults": "Erwachsene",
  "main.corporate_code": "Firmen-Code",
  "main.group_code": "Gruppencode",
  "main.promo_code": "Aktionscode",
  "main.ai_response": "KI-Antwort",
  "main.template_response": "Vorlagenantwort",
  "main.converttoticket": "In Ticket umwandeln",
  "main.switch_property": "Unterkunft wechseln",
  "main.Group_id": "Gruppen-ID",
  "main.integration_id": "Integrations-ID",
  "main.submit": "Senden",
  "main.cancel": "Abbrechen",
  "main.select_template": "Vorlage auswählen",
  "main.rooms": "Zimmer",
  "main.rates": "Preise",

  //footer
  "footer.knowledge": "Wissen",
  "footer.home": "Startseite",
  "footer.help": "Hilfe",

  //ticket
  "ticket.thank_you": "Vielen Dank für das Absenden des Formulars",
  "ticket.ticket": "Ticket",
  "ticket.details": "Bitte füllen Sie das Formular mit den Ticketdetails aus.",
  "ticket.select_category": "Kategorie auswählen",
  "ticket.category": "Kategorie",
  "ticket.title": "Titel",
  "ticket.notes": "Notizen",
  "ticket.status": "Status",
  "ticket.assigned_to": "Zugewiesen an",
  "ticket.submit_form": "Formular absenden",

  
  "main.total": "Gesamt",
  "main.pastetooutlook": "In Outlook einfügen",
  "main.children": "Kinder",
  "main.promocode": "Promo-/Firmen-/Gruppencode",
  "main.exact_match_only": "Nur exakte Übereinstimmung",
  "main.search": "Suchen",
  "main.no_rate_match": "Keine Preise entsprechen Ihrer Auswahl. Bitte ändern Sie Ihre Suche und versuchen Sie es erneut.",
  "main.translate_to": "Übersetzen nach",
  "main.regenerate": "Neu generieren",
  "main.copy_text": "Text kopieren",
  "main.additional_instructions": "Zusätzliche Anweisungen",

  "faq.helpcenter": "Hilfezentrum",
  "faq.reply.email.sabre.question": "Wie beantworte ich eine E-Mail mit der Aven Hospitality Concierge E-Mail-Automatisierung?",
  "faq.reply.email.sabre.answer": "Öffnen Sie die E-Mail und starten Sie das Aven Hospitality Add-in. Sie können zwischen drei Optionen wählen: eine vordefinierte Vorlage verwenden, eine KI-Antwort erstellen oder die E-Mail in ein Ticket umwandeln. Wählen Sie die passende Option, überprüfen Sie die Antwort, bearbeiten Sie sie bei Bedarf und senden Sie sie direkt aus Outlook.",

  "faq.rates.availability.question": "Wie füge ich Preise, Verfügbarkeit und Zimmerdetails zu meiner Antwort hinzu?",
  "faq.rates.availability.answer": "Verwenden Sie die Funktion + Rates, um Gästedaten wie Daten und Anzahl der Gäste einzugeben. Concierge fügt dann genaue Verfügbarkeit und Preise in Ihre Antwort ein. Sie können auch + Rooms verwenden, um Zimmerbeschreibungen und Bilder hinzuzufügen.",

  "faq.different.language.question": "Was soll ich tun, wenn die E-Mail in einer anderen Sprache ist?",
  "faq.different.language.answer": "Aven Hospitality Concierge ermöglicht es Ihnen, eingehende E-Mails in Ihre bevorzugte Sprache zu übersetzen. Anschließend können Sie eine Antwort erstellen oder bearbeiten und sie vor dem Senden wieder in die Sprache des Gastes übersetzen.",

  "faq.pin.addin.question": "Wie stelle ich sicher, dass das Add-in immer in Outlook verfügbar ist?",
  "faq.pin.addin.answer": "Um Aven Hospitality Concierge immer sichtbar zu halten, heften Sie das Add-in in Outlook an. Dadurch wird es automatisch mit jeder E-Mail geöffnet.",

  "faq.knowledge.hub.question": "Was ist die Knowledge Hub-Suchoption?",
  "faq.knowledge.hub.answer": "Mit der Knowledge Hub-Suche können Sie schnell objektspezifische Informationen direkt in Outlook finden.",

  "faq.reply.email.myma.question": "Wie beantworte ich eine E-Mail mit Myma?",
  "faq.reply.email.myma.answer": "Öffnen Sie die E-Mail und starten Sie das Myma Add-in. Sie können eine Vorlage verwenden, eine KI-Antwort erstellen oder die E-Mail in ein Ticket umwandeln.",

  "faq.room.details.question": "Wie füge ich Zimmerdetails zu meiner Antwort hinzu?",
  "faq.room.details.answer": "Verwenden Sie + Rooms, um Zimmerbeschreibungen und Bilder hinzuzufügen.",

  "faq.myma.different.language.question": "Was soll ich tun, wenn die E-Mail in einer anderen Sprache ist?",
  "faq.myma.different.language.answer": "Myma ermöglicht die Übersetzung eingehender E-Mails in Ihre bevorzugte Sprache.",

  "faq.myma.pin.addin.question": "Wie stelle ich sicher, dass das Add-in immer in Outlook verfügbar ist?",
  "faq.myma.pin.addin.answer": "Heften Sie das Myma Add-in in Outlook an, damit es automatisch mit jeder E-Mail geöffnet wird."

};
export default deMessages;